import { useNavigate } from "react-router-dom";
import { SubmitHandler } from "react-hook-form";
import Page from "src/layouts/Page";
import QuickLinkForm, {
	QuickLinkFormValues
} from "../../components/QuickLinkForm/QuickLinkForm";
import useCreateQuickLink from "../../hooks/useCreateQuickLink";
import { adaptCreateQuickLinkPayload } from "../../adapters/adaptQuickLinkPayload";
import { formValuesToQuickLink } from "../../adapters/formValuesToQuickLink";

const EMPTY_DEFAULTS: QuickLinkFormValues = {
	heading: "",
	content: "",
	buttonLink: "",
	webview: true,
	feedId: null,
	selectedFeed: null,
	audienceGroupIds: []
};

const CreateQuickLink = () => {
	const navigate = useNavigate();
	const { mutate: createQuickLink, isLoading } = useCreateQuickLink();

	const handleSubmit: SubmitHandler<QuickLinkFormValues> = (data) => {
		const payload = adaptCreateQuickLinkPayload(formValuesToQuickLink(data));

		createQuickLink(payload, {
			onSuccess: () => navigate("/app/homepage/quick-links")
		});
	};

	return (
		<Page>
			<QuickLinkForm
				defaultValues={EMPTY_DEFAULTS}
				onSubmit={handleSubmit}
				isSubmitting={isLoading}
			/>
		</Page>
	);
};

export default CreateQuickLink;
